import React, { useEffect } from "react";
import { useState } from "react";
import "./dashboard.css";
import config from "../../../helper/config.js";
import { customerConstants } from "../../../helper/constants.js";
import PaidIcon from "@mui/icons-material/Paid";
import { Dropdown } from "react-bootstrap";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
import AreaChart from "../charts/AreaChart.js";
import GroupedBarChart from "../charts/GroupedBarChart.js";
import { Spinner } from "react-bootstrap";
import { CircularProgress } from "@mui/material";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { TreeMainService } from "../../../service/manage/h_tree/tree_main.service.js";
import { useHistory } from "react-router-dom";
import { formFixture } from "../hierarchy/FormFixture.js";
import Skeleton from "@mui/material/Skeleton";
const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let iconColor;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    iconColor = "var(--maincolor)";
    break;
  case customerConstants.EXO_CUSTOMER2:
    iconColor = "var(--maincolor-cmc)";
    break;
  default:
    iconColor = "var(--maincolor)";
    break;
}

const Income = ({
  suitableArray,
  dashboardDataLoading,
  teacherEnrollments,
  enrollmentDataLoading,
}) => {
  const history = useHistory();
  const [monthBasedIncome, setMonthBasedIncome] = useState(undefined);
  const [selectedIncome, setSelectedIncome] = useState(null);
  const [chartType1Data, setChartType1Data] = useState([]);

  useEffect(() => {
    fetchSuitableIncome();
  }, [suitableArray]);

  useEffect(() => {
    filterTotalAmount(selectedIncome);
  }, [selectedIncome]);

  const filterTotalAmount = (selectedIncome) => {
    const suitableArray1 = suitableArray?.find(
      (item) =>
        item.chart_type === "ChargeableFees-info1" && item.chart_id === 2300
    );
    if (suitableArray1) {
      const groupedData = suitableArray1?.array.reduce((acc, obj) => {
        const key = `${obj.flg_chart_legend_x_filter}`;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
      }, {});
      if (groupedData) {
        const filteredGroupedData = Object.values(groupedData);
        const selectedTotalAmount = filteredGroupedData.find(
          (item) =>
            selectedIncome[0]?.flg_chart_legend_x_filter ===
            item[0].flg_chart_legend_x_filter
        );
        setChartType1Data(selectedTotalAmount);
      }
    }
  };

  const fetchSuitableIncome = () => {
    const suitableArray2 = suitableArray?.find(
      (item) =>
        item.chart_type === "ChargeableFees-info2" && item.chart_id === 2300
    );
    if (suitableArray2) {
      const groupedData = suitableArray2.array.reduce((acc, obj) => {
        const key = `${obj.flg_chart_legend_x_filter}`;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
      }, {});
      if (groupedData) {
        const filteredGroupedData = Object.values(groupedData);
        setMonthBasedIncome(filteredGroupedData);
        setSelectedIncome(filteredGroupedData[0]);
      }
    }
  };

  const renderStatsCharts = () => {
    const renderOuterComponent = (Component, val_) => {
      return (
        <div
          className="row d-flex justify-content-around chart-container w-100"
          style={{ marginBottom: "20px" }}
        >
          <div className="col-lg-12 col-md-12 d-flex justify-content-center pb-md-3 pb-sm-3">
            <Component val={val_} />
          </div>
        </div>
      );
    };
    const constructedArray = suitableArray.map((val, index) => {
      let applyValues = val.array;
      if (val.chart_type == "Monthly-Revenue") {
        return renderOuterComponent(AreaChart, applyValues);
      }
    });
    return constructedArray;
  };

  const handleApplicationSelect = (formData) => {
    const state = {
      pid: formData.pid,
      mid: formData.node_mid,
      lg_user_id: formData.lg_user_id,
      lg_user_table_id: formData.lg_user_table_id,
      flg_list_active: formData.flg_list_active,
      privilege_view: formData.privilege_view,
      privilege_edit: formData.privilege_edit,
      privilege_add: formData.privilege_add,
      privilege_delete: formData.privilege_delete,
      owner_restriction: formData.owner_restriction,
      user_list_restriction: formData.user_list_restriction,
      form_display_title: formData.form_display_title,
      form_display_order: formData.form_display_order,
      form_list_id: formData.form_list_id,
      breadcrumb2: formData.breadcrumb,
      main_table_id: formData.main_table_id,
      nodeTitle: formData.tree_main_title || "",
      node_mid_actual: formData.node_mid_actual,
      path: "dashboard",
      mcode: formData.mcode,
    };

    const componentDetail = formFixture(state).find(
      (item) => formData.form_list_id === item.formListId
    );

    if (componentDetail?.url) {
      history.push({
        pathname: componentDetail.url,
        state: { ...state },
      });
    }
  };

  return (
    <div className="row d-flex">
      <div className="col-md-12 mb-3 pl-0 px-0 px-sm-0">
        {dashboardDataLoading ? (
          <div className="dashboard__container">
            {/* Title Skeleton */}
            <div className="row d-flex justify-content-between align-items-center my-3">
              <div className="skeleton-title" style={{
                width: '200px',
                height: '24px',
                borderRadius: '4px',
                backgroundColor: '#f0f0f0'
              }}></div>
              <div className="skeleton-dropdown" style={{
                width: '120px',
                height: '32px',
                borderRadius: '6px',
                backgroundColor: '#f0f0f0'
              }}></div>
            </div>

            {/* Card Skeleton */}
            <div className="row d-flex dashboard__count-cards-orange align-items-center py-3" style={{
              backgroundColor: '#f0f0f0',
              borderRadius: '8px'
            }}>
              <div className="col-md-2 col-2 p-0 d-flex align-items-center justify-content-center">
                <div className="skeleton-icon" style={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  backgroundColor: '#e0e0e0'
                }}></div>
              </div>
              <div className="col-md-10 col-10">
                <div className="skeleton-text" style={{
                  width: '100px',
                  height: '16px',
                  marginBottom: '8px',
                  backgroundColor: '#e0e0e0',
                  borderRadius: '4px'
                }}></div>
                <div className="skeleton-amount" style={{
                  width: '150px',
                  height: '28px',
                  backgroundColor: '#e0e0e0',
                  borderRadius: '4px'
                }}></div>
              </div>
            </div>

            {/* List Items Skeleton */}
            <div className="row my-5">
              {[...Array(5)].map((_, index) => (
                <div key={index} className="row d-flex justify-content-between mb-3">
                  <div className="skeleton-item-title" style={{
                    width: `${Math.random() * 100 + 100}px`,
                    height: '18px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '4px'
                  }}></div>
                  <div className="skeleton-item-value" style={{
                    width: '80px',
                    height: '18px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '4px'
                  }}></div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="dashboard__container">
            <div className="row d-flex justify-content-between align-items-center my-3">
              <h3 className="dashboard__container-title m-0">
                <SavingsRoundedIcon sx={{ fontSize: 22, color: "#5c5c5c" }} />{" "}
                Chargeable Fees
              </h3>
              <div className="">
                <Dropdown>
                  <Dropdown.Toggle
                    variant="primary"
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: "#fff",
                      border: "1px solid #E4E6EF",
                      color: "var(--secondary-text-color)",
                      fontWeight: "400",
                      fontSize: "10px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "120px",
                    }}
                  >
                    <span style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      marginRight: "8px"
                    }}>
                      {selectedIncome && selectedIncome[0]?.flg_chart_legend_x_filter}
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {monthBasedIncome &&
                      monthBasedIncome.map((obj) => (
                        <Dropdown.Item
                          key={obj[0].flg_chart_legend_x_filter}
                          onClick={() => {
                            setSelectedIncome(obj);
                          }}
                          style={{
                            whiteSpace: "normal",
                            // wordBreak: "break-word", 
                            minWidth: "200px",
                            maxWidth: "300px"
                          }}
                        >
                          {obj[0].flg_chart_legend_x_filter}
                        </Dropdown.Item>
                      ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <div className="row d-flex dashboard__count-cards-orange align-items-center py-3">
              <div className="col-md-2 col-2 p-0 revenue__icon d-flex align-items-center">
                <SavingsRoundedIcon
                  sx={{
                    fontSize: 15,
                    color: "#fff",
                  }}
                />
              </div>
              {chartType1Data?.map((obj) => (
                <div className="col-md-10 col-10">
                  <p className="revenue-text">{obj.chart_x_value}</p>
                  <h3 className="revenue-amount m-0">{obj.chart_y_value}</h3>
                </div>
              ))}
            </div>
            <div className="row my-5">
              <div className="col-md-12 px-0">
                {selectedIncome?.map((obj) => (
                  <div className="row d-flex justify-content-between receivables-row">
                    <h5 className="receivables-title m-0">
                      {obj.chart_x_value}
                    </h5>
                    <p className="receivables-amount">{obj.chart_y_value}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {/* <h3 className="dashboard-subheading m-0 mt-8 pt-5">
                Monthly Revenue
              </h3> */}

        <div className="dashboard__container mt-3">
          <div className="row d-flex justify-content-between align-items-center my-3">
            <h3 className="dashboard__container-title m-0">
              <HowToRegIcon sx={{ fontSize: 22, color: "#5c5c5c" }} /> Teacher
              enrollment
            </h3>
          </div>

          {enrollmentDataLoading ? (
            <div className="my-3 py-3">
              {/* Skeleton loading state */}
              {[...Array(3)].map((_, idx) => (
                <div
                  key={idx}
                  className="d-flex align-items-center mb-3"
                  style={{ height: "32px" }}
                >
                  <Skeleton variant="circular" width={20} height={20} />
                  <Skeleton
                    variant="text"
                    width={Math.random() * 100 + 150}
                    height={24}
                    sx={{ ml: 1 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={32}
                    height={32}
                    sx={{ ml: 1, borderRadius: 1 }}
                  />
                </div>
              ))}
            </div>
          ) : teacherEnrollments.length > 0 ? (
            teacherEnrollments.map((enrollment, index) => (
              <div key={index}>
                {enrollment.breadcrumb && (
                  <div className="d-flex align-items-center mb-3">
                    <ArrowRightIcon />

                    <span
                      className="stu-variant-class label label-lg label-light-success label-inline announcement__breadcrumb"
                      style={{
                        cursor: "pointer",
                        marginLeft: "8px",
                        color: "#1976d2",
                      }}
                      onClick={() => handleApplicationSelect(enrollment)}
                    >
                      {enrollment?.breadcrumb} {enrollment?.form_display_title}
                    </span>

                    <span
                      style={{
                        border: "1px solid #E4E6EF",
                        borderRadius: "4px",
                        padding: "4px",
                        display: "flex",
                        marginLeft: "8px",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        backgroundColor: "#f9f9f9",
                        transition: "background-color 0.2s ease",
                      }}
                      onClick={() => handleApplicationSelect(enrollment)}
                      title="Go to application"
                      onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor = "#f1f1f1")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor = "#f9f9f9")
                      }
                    >
                      <ArrowForwardIcon fontSize="small" />
                    </span>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="text-muted">No enrollment data available</div>
          )}
        </div>

        <div className="row">{renderStatsCharts()}</div>
      </div>
    </div>
  );
};

export default Income;
